export const headerData = {
  universalNav: {
    joyWedding: 'Joy Wedding',
    joyBaby: 'Joy Baby',
    new: 'New',
    findAnEvent: 'Find an Event',
  },
  header: {
    login: 'Log in',
    getStarted: 'Get Started',
    backToAll: 'Back to All',
    findAnEvent: 'Find an Event',
  },
  footer: {
    shipping: 'Shipping',
    returns: 'Returns',
    newsroom: 'Newsroom',
    careers: 'Careers',
    aboutJoy: 'About Joy',
    contactUs: 'Contact Us',
    login: 'Log in',
    getStarted: 'Get Started',
    findAnEvent: 'Find an Event',
    copyright: 'All rights reserved.',
    terms: 'Terms',
    privacy: 'Privacy',
    californiaPrivacyNotice: 'California Privacy Notice',
    doNotShareInformation: 'Do not share my personal information.',
  },
  hotelRoomBlockValueProps: [
    {
      title: 'Hotel Room Blocks',
    },
    {
      title: 'Exclusive Room Rates',
    },
    {
      title: 'Up To 30% Off',
    },
    {
      title: 'No Financial Commitment',
    },
    {
      title: 'Personal Travel Concierge',
    },
  ],
} as const;
